import React from 'react';
import { motion } from 'framer-motion';
interface StatTileProps {
  label: string;
  value: string | number;
  sub: string;
  accent?: string;
  index?: number;
}
export function StatTile({
  label,
  value,
  sub,
  accent = 'rgb(var(--productc))',
  index = 0
}: StatTileProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: index * 0.06,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative overflow-hidden rounded-2xl border border-ink-700 bg-ink-850 px-5 py-4 shadow-panel" data-id="element-114" data-mp="1ffwmkhi1500l">
      <span className="absolute inset-y-0 left-0 w-[3px]" style={{
      backgroundColor: accent
    }} aria-hidden="true" data-id="element-115" data-mp="11g52q04u0peo" />
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-faint" data-id="element-116" data-mp="wponcahgatpo">{label}</p>
      <p className="mt-2 font-display text-4xl leading-none text-chalk" data-id="element-117" data-mp="8zkn8d3h1c3f">{value}</p>
      <p className="mt-2 text-xs leading-relaxed text-mute" data-id="element-118" data-mp="8xhon4o96an3">{sub}</p>
    </motion.div>;
}